import React from 'react';

const MotionControllers = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 84.882 65.758"
			className={className}
		>
			<g fill="currentColor">
				<path d="M0 65.758h84.882V0H0ZM3.766 3.766h77.351v58.226H3.766Z" />
				<path d="M28.079 43.286a5 5 0 0 0-8.407 2.406h-8.019v2.259h8.02a5 5 0 0 0 9.742 0h8.021v-2.259h-8.019a4.984 4.984 0 0 0-1.335-2.406Zm-1.6 5.475a2.741 2.741 0 1 1 .8-1.939 2.73 2.73 0 0 1-.798 1.939Z" />
				<path d="M33.563 28.292a5 5 0 0 0-4.871 3.871h-17.04v2.259h17.04a5 5 0 1 0 4.871-6.131Zm1.939 6.94a2.741 2.741 0 1 1 .8-1.939 2.73 2.73 0 0 1-.8 1.939Z" />
				<path d="M15.523 24.766a5 5 0 0 0 4.871-3.871h17.04v-2.259h-17.04a5 5 0 1 0-4.871 6.131Zm-1.939-6.94a2.741 2.741 0 1 1-.8 1.939 2.73 2.73 0 0 1 .8-1.939Z" />
				<path d="M44.332 23.536h7.543v-7.543h-7.543Zm2.259-5.283h3.024v3.02h-3.023Z" />
				<path d="M44.332 36.637h7.543v-7.543h-7.543Zm2.259-5.283h3.024v3.024h-3.023Z" />
				<path d="M44.332 50.595h7.543v-7.543h-7.543Zm2.259-5.283h3.024v3.024h-3.023Z" />
				<path d="M55.577 23.536h7.54v-7.543h-7.54Zm2.259-5.283h3.024v3.02h-3.024Z" />
				<path d="M55.577 36.637h7.54v-7.543h-7.54Zm2.259-5.283h3.024v3.024h-3.024Z" />
				<path d="M55.577 50.595h7.54v-7.543h-7.54Zm2.259-5.283h3.024v3.024h-3.024Z" />
				<path d="M66.822 23.536h7.543v-7.543h-7.543Zm2.259-5.283h3.024v3.02h-3.023Z" />
				<path d="M66.822 36.637h7.543v-7.543h-7.543Zm2.259-5.283h3.024v3.024h-3.023Z" />
				<path d="M66.822 50.595h7.543v-7.543h-7.543Zm2.259-5.283h3.024v3.024h-3.023Z" />
			</g>
		</svg>
	);
};

export default MotionControllers;
